export const chartTimelineSMS = {
  series: [
    {
      name: "Envoyés",
      data: [], // Set nb of SENT messages
    },
    {
      name: "Reçus",
      data: [], // Set nb of RECEIVED messages
    },
  ],
  options: {
    chart: {
      type: "line",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    colors: ["#6737FF", "#B0B0C8"],

    labels: {
      style: {
        fontSize: "14px",
      },
    },

    dataLabels: {
      enabled: true,
      formatter: function(value: number) {
        if(value > 0) {
          return value;
        } else {
          return "";
        }
      }
    },

    grid: {
      borderColor: "#DFE6E9",
      row: {
        opacity: 0.5,
      },
    },

    stroke: { //https://apexcharts.com/docs/options/stroke/
      show: true,
      curve: 'smooth', // 'smooth' or 'straight'
      lineCap: 'butt',
      width: 2,
      dashArray: 0, 
    },

    xaxis: {
      axisTicks: {
        show: false,
        borderType: "solid",
        color: "#78909C",
        height: 6,
        offsetX: 0,
        offsetY: 0,
      },
      tickPlacement: "between",
      labels: {
        style: {
          colors: ["636E72"],
          fontSize: "12px",
        },
      },
      categories: [],   // Set dates
    },
    legend: {
      show: false,
    },
    yaxis: {
      labels: {
        style: {
          colors: ["636E72"],
          fontSize: "12px",
        },
        formatter: (value: number) => {
          return Math.round(value);
        },
      },
      min: 0,
      tickAmount: 3,
    },
  },
}

